import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import CreateIcon from '@material-ui/icons/Create';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';

const QuickEditButton = ({
  resource,
}) => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { loadModalCollectionByLink } = useModalContext();
  return (
    <IconButton
      onClick={resource.relationship(fr.relationships.outcomeQuickEdit.name) ? (e) => {
        e.stopPropagation();
        loadModalCollectionByLink(resource.relationship(fr.relationships.outcomeQuickEdit.name).link('related').url());
        logStandardizedEvent(categories.whatIf, eventTypes.clickButton, 'quick edit outcome');
      } : null}
      color={'inherit'}
      icon={CreateIcon}
      title={'Quick Edit Outcome'}
      test={`scenario-summary-card-quick-edit-button-${resource.id()}`}
    />
  );
};

QuickEditButton.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default QuickEditButton;
